<div class="ucd-backdrop" role="dialog" aria-modal="true" aria-labelledby="ucd-title" (click)="pick('stay')">
  <div class="ucd-card" (click)="$event.stopPropagation()">
    <div class="ucd-header">
      <div class="ucd-badge"><i class="fa-solid fa-triangle-exclamation"></i></div>
      <button type="button" class="ucd-x" aria-label="Close" (click)="pick('stay')">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="ucd-text">
      <h3 id="ucd-title" class="ucd-title">Unsaved Changes</h3>
      <p class="ucd-message">
        You have unsaved changes. If you cancel or navigate away, your entered data will be lost. Are you sure you want
        to proceed?
      </p>
    </div>

    <div class="ucd-footer">
      <button type="button" class="ucd-btn ucd-btn--secondary" (click)="pick('close')">Close</button>
      <button type="button" class="ucd-btn ucd-btn--primary" (click)="pick('stay')">Stay Here</button>
    </div>
  </div>
</div>
